import { PRIORITY_RANK } from '@/entities/shared/priority/priority-rank';
import type { Task } from '../schemas/task';

export function compareTasks(a: Task, b: Task): number {
  return (
    PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority] ||
    (a.due_on ?? '9999').localeCompare(b.due_on ?? '9999') ||
    a.title.localeCompare(b.title, 'es')
  );
}
